<template>
  <Guide :titleList="titleList">
    <template #innerContent>
      <div class="whatsapp-doc-page">
        <div class="whatsapp-doc-page__spacer"></div>

        <WhatsAppDocRenderer :blocks="whatsappDocIntroBlocks" />

        <section
          v-for="section in whatsappDocSections"
          :id="section.id"
          :key="section.id"
          class="whatsapp-doc-page__section"
        >
          <CollapseItem
            :title="t(section.titleKey)"
            :level="1"
            v-model:visible="collapseState[section.id]"
          >
            <div class="whatsapp-doc-page__section-content">
              <WhatsAppDocRenderer
                v-if="section.blocks.length"
                :blocks="section.blocks"
              />

              <div
                v-for="childSection in section.childSections"
                :id="childSection.id"
                :key="childSection.id"
                class="whatsapp-doc-page__child-section"
              >
                <CollapseItem
                  :title="t(childSection.titleKey)"
                  :level="2"
                  v-model:visible="collapseState[childSection.id]"
                >
                  <WhatsAppDocRenderer :blocks="childSection.blocks" />
                </CollapseItem>
              </div>
            </div>
          </CollapseItem>
        </section>
      </div>
    </template>
  </Guide>
</template>

<script setup>
import { computed, reactive } from "vue"
import { useI18n } from "vue-i18n"
import Guide from "@/views/FileDoc/components/Guide.vue"
import CollapseItem from "@/views/FileDoc/components/CollapseItem.vue"
import WhatsAppDocRenderer from "@/views/WhatsApp/components/WhatsAppDocRenderer.vue"
import {
  createWhatsappDocCollapseState,
  createWhatsappDocTitleList,
  whatsappDocIntroBlocks,
  whatsappDocSections,
} from "@/views/WhatsApp/components/whatsappDocSchema"

const { t } = useI18n()

const collapseState = reactive(createWhatsappDocCollapseState())

const titleList = computed(() => createWhatsappDocTitleList(t, collapseState))
</script>

<style lang="less" scoped>
.whatsapp-doc-page {
  width: 100%;
  padding-bottom: 60px;
}

.whatsapp-doc-page__spacer {
  width: 100%;
  height: 50px;
  margin-top: 30px;
}

.whatsapp-doc-page__section {
  margin-top: 30px;
}

.whatsapp-doc-page__section-content {
  padding-top: 8px;
}

.whatsapp-doc-page__child-section + .whatsapp-doc-page__child-section {
  margin-top: 8px;
}

:deep(.el-icon) {
  font-size: 16px !important;
}
</style>

